export default __webpack_public_path__ + "static/hero-desktop-de-db9546ef763bcdba41d134a1f4ec6213.png";